import { useContext } from 'react';
import { DialogContext } from './DialogContext';

const useDialogContext = (hookName: string) => {
    const dialogContext = useContext(DialogContext);

    if (!dialogContext) {
        throw new Error(`${hookName} must be used within DialogProvider!`);
    }

    return dialogContext;
};

export const useNestedDialogFunction = () => {
    const { openNewDialog, closeLastDialog } = useDialogContext(
        'useNestedDialogFunction'
    );

    return {
        showNestedDialog: openNewDialog,
        closeNestedDialog: closeLastDialog,
    };
};

export const useIsDialogOpened = () => {
    const { isOpened } = useDialogContext('useIsDialogOpened');
    return isOpened;
};

export const useGetNumberOfOpenedDialogs = () => {
    const { numberOfOpenDialogs } = useDialogContext(
        'useGetNumberOfOpenedDialogs'
    );
    return numberOfOpenDialogs;
};

export const useCloseAllDialogs = () => {
    const { closeAllDialogs } = useDialogContext('useCloseAllDialogs');
    return closeAllDialogs;
};
